import { Injectable } from '@angular/core';
import { getMessaging, onMessage, getToken } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagingService {
  currentMessage = new BehaviorSubject<any>(null);

  private messaging = getMessaging(initializeApp(environment.firebase));

  requestPermission() {
    Notification.requestPermission().then((permission) => {
      console.log('Notification permission:', permission);
      if (permission === 'granted') {
        getToken(this.messaging)
          .then((token) => {
            if (token) {
             // console.log('FCM Token:', token);
              localStorage.setItem('pushToken', token);
            } else {
              console.warn('No registration token available');
            }
          })
          .catch((err) => console.error('Token error:', err));
      }
    });
  }

  listen() {
    onMessage(this.messaging, (payload) => {
      console.log('Foreground message received:', payload);
      alert(`${payload.notification?.title}\n${payload.notification?.body}`);
      this.currentMessage.next(payload);
    });
  }
}
